/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SyncStatus = "ACTIVE" | "BLOCKED" | "CANCELLED" | "DUPLICATE" | "NEW" | "PENDING" | "REJECTED" | "%future added value";
export type EditAccountQueryVariables = {};
export type EditAccountQueryResponse = {
    readonly account: {
        readonly status: SyncStatus;
    } | null;
    readonly configuration: {
        readonly hiddenFields: string;
    } | null;
};
export type EditAccountQuery = {
    readonly response: EditAccountQueryResponse;
    readonly variables: EditAccountQueryVariables;
};



/*
query EditAccountQuery {
  account {
    status
    id
  }
  configuration {
    hiddenFields
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "concreteType": "Configuration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hiddenFields",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "EditAccountQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/)
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditAccountQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/)
            ]
        },
        "params": {
            "cacheID": "dc0be36848c95f39f5d1d399df0e2fd8",
            "id": null,
            "metadata": {},
            "name": "EditAccountQuery",
            "operationKind": "query",
            "text": "query EditAccountQuery {\n  account {\n    status\n    id\n  }\n  configuration {\n    hiddenFields\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '5eaafc3a8d71ca7179e64c619a471e93';
export default node;
